import React from "react";
import { connect } from "react-redux";
import Box from "signoxe/components/layout/Box";
import Button from "signoxe/components/widgets/Button";
import { addQuizAsset, setPageTitle, setQuizStations, addUrlAsset } from "signoxe/actions";
import { API_ROOT } from "signoxe/constants/config";

class PollAppPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      selected_poll:"",
      polls:[]
    };
  }

  componentDidMount() {
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${this.props.token}`,
      },
    };

    fetch(`${API_ROOT}polls/`, requestOptions)
      .then((response) => {
        if (response.ok) {
          console.log("response", response)
          return response.json();
        }
      })
      .then((obj) => {
        if (obj) {
          console.log("quiz app", obj)
          this.setState({ polls: obj});
          console.log("p render props", this.state.polls)
        }
      });

    this.props.setPageTitle("Adding Poll Asset");
  }

  render() {
    console.log("poll", this.state.polls)
    console.log("poll selected", this.state.selected_poll)


    return (
      <div className="asset-editing-page">
        <p>Poll Asset App </p>
        <input
          type="text"
          placeholder="Asset name"
          value={this.state.name}
          onChange={(event) => this.setState({ name: event.target.value })}
        />
        {this.state.polls.length > 0 ? (
          <select
            name="selected_poll"
            onChange={(event) => this.changeSelectedStation(event.target.value)}
            value={this.state.selected_poll.screen_view_url}
          >
            <option value="">Please choose a poll</option>
            {this.state.polls.map((poll) => (
              <option key={`${poll.id}`} value={poll.screen_view_url}>
                {poll.name}
              </option>
            ))}
          </select>
        ) : (
          <p>Loading polls...</p>
        )}

        <Box
          direction="row"
          justifyContent="flex-end"
          className="actions button-group"
        >
          <Button
            primary
            onClick={this.saveEnabled() ? (event) => this.save() : null}
          >
            Save
          </Button>
          {/* <Button secondary onClick={event => this.props.disable()}>Cancel</Button> */}
        </Box>
      </div>
    );
  }

  changeSelectedStation(selected_poll) {
    this.setState({ selected_poll });
  }

  saveEnabled() {
    return this.state && this.state.name && this.state.selected_poll;
  }

  cancel() {
    this.props.history.push("/assets");
  }

  save() {
    const {selected_poll, name} = this.state
    this.props.addUrlAsset({
      name: name,
      asset_url: selected_poll,
    });
    setTimeout(this.props.refresh, 700);
  }

  isNewAsset() {
    return this.props.match.params.id === undefined;
  }
}

const mapStateToProps = (state, ownProps) => {
  const quizStations = state.uiState.quizStations;
  return {
    stations: quizStations,
    token: state.authState.token,
    // asset: getAsset(state, parseInt(ownProps.match.params.id, 10)),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPageTitle: (title) => dispatch(setPageTitle(title)),
    addUrlAsset: data => dispatch(addUrlAsset(data)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PollAppPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Poll_App.js